module.exports = __webpack_public_path__ + "img/4.aa438614.jpg";